import {useMemo} from 'react'
import {useDispatch} from 'react-redux'
import {bindActionCreators} from 'redux'
import * as actions from './action-creators'

const useActions = (): typeof actions => {
    const dispatch = useDispatch()

    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    return useMemo(() => bindActionCreators(actions, dispatch), [dispatch])
}

export default useActions
